// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"a2c87710","595":"21c76e6e","602":"8f79ef71","699":"0ef0e99b","787":"c8eeaae9","827":"4090a51a"}[chunkId] + ".chunk.js";
};